import {QuestionCircleOutlined} from "@ant-design/icons";
import {Button, Tooltip} from "antd";
import {TooltipProps} from "antd/lib/tooltip";

type UiTooltipProps = TooltipProps & {};

export function UiTooltip(props: UiTooltipProps) {
  return (
    <Tooltip {...props}>
      <Button icon={<QuestionCircleOutlined />} size="small" type="text" />
    </Tooltip>
  );
}
